import authReducer from "../redux/auth/authSlice";
import adminReducer from "../redux/admin/adminSlice";
import userReducer from "../redux/user/userSlice";
import fdReducer from "../redux/fd/fdSlice";
import mfReducer from "../redux/mf/mfSlice";
import pmsReducer from "../redux/pms/pmsSlice";
import stockReducer from "../redux/stocks/stockSlice";
import bondReducer from "../redux/bonds/bondSlice";
import bankReducer from "../redux/bank/bankSlice";
import nomineeReducer from "../redux/nominee/nomineeSlice";
import dematReducer from "../redux/demat/dematSlice";
import preferenceReducer from "./preference/preferenceSlice";
import notificationReducer from "./notification/notificationSlice";
import aifReducer from "./portfolio/aif/aifSlice";
import changeStatusReducer from "./portfolio/changeStatus/statusSlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import rmReducer from "./rm/rmSlice";

import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    auth: authReducer,
    user: userReducer,
    fd: fdReducer,
    bank: bankReducer,
    nominee: nomineeReducer,
    demat: dematReducer,
    preference: preferenceReducer,
    notification: notificationReducer,
    mf: mfReducer,
    pms: pmsReducer,
    stock: stockReducer,
    bond: bondReducer,
    aif: aifReducer,
    status: changeStatusReducer,
    dashboard: dashboardReducer,
    rm: rmReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
